import { render, staticRenderFns } from "./ResourceCard.vue?vue&type=template&id=584a3caa"
import script from "./ResourceCard.vue?vue&type=script&lang=js"
export * from "./ResourceCard.vue?vue&type=script&lang=js"
import style0 from "./ResourceCard.vue?vue&type=style&index=0&id=584a3caa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports